import React from "react";
import moment from "moment";
import { ColumnsType } from "antd/lib/table";
import { Table, Tag } from "../../atoms";
import { ICustomerCoupon37856 } from "../../../common/types";
import { EmptyState } from "./Customer.style";

interface ICustomerCouponsProps {
  coupons: ICustomerCoupon37856[];
  loading?: boolean;
}

const formatDate = (value: any) => {
  if (!value) {
    return "—";
  }
  if (moment.isMoment(value)) {
    return value.format("DD/MM/YYYY");
  }
  if (typeof value?.toDate === "function") {
    return moment(value.toDate()).format("DD/MM/YYYY");
  }
  return moment(value).format("DD/MM/YYYY");
};

export const CustomerCoupons: React.FC<ICustomerCouponsProps> = ({
  coupons,
  loading,
}) => {
  const columns: ColumnsType<ICustomerCoupon37856> = [
    {
      title: "Όνομα κουπονιού",
      dataIndex: "couponName",
      key: "couponName",
      render: (value: string) => (
        <a href="#" onClick={(event) => event.preventDefault()}>
          {value}
        </a>
      ),
    },
    {
      title: "Εκπτωτικός κωδικός",
      dataIndex: "couponCode",
      key: "couponCode",
      render: (value: string) => (
        <Tag color="blue" style={{ fontWeight: 600 }}>
          {value}
        </Tag>
      ),
    },
    {
      title: "Από",
      dataIndex: "startDate",
      key: "startDate",
      render: formatDate,
    },
    {
      title: "Μέχρι",
      dataIndex: "endDate",
      key: "endDate",
      render: formatDate,
    },
    {
      title: "Έκπτωση %",
      dataIndex: "discountPercentage",
      key: "discountPercentage",
      render: (value: number) => `${value || 0} %`,
    },
    {
      title: "Χρήση",
      dataIndex: "usageLimit",
      key: "usageLimit",
      render: (value: number) => `${value || 0} φορά`,
    },
  ];

  if (!loading && coupons.length === 0) {
    return <EmptyState>Δεν υπάρχουν κουπόνια</EmptyState>;
  }

  return (
    <Table
      rowKey={(record) => record.id}
      columns={columns}
      dataSource={coupons}
      pagination={false}
      loading={loading}
    />
  );
};
